const path = '/img/solutions/e-commerce';
const placeholder = '/img/solutions/entertainment';

export const BANNER = {
  title: '电商行业解决方案',
  description:
    '聚焦电商场景，结合人工智能、虚拟现实等技术快速为其注入新的产业创新方向，实现降低运营成本、提升品牌营销效果和GMV转换等目标',
  buttonText: '立即咨询',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  docText: '产品文档',
};

export const ARCHITECTURE = {
  title: '方案架构',
  picUrl: `${path}/architecture.webp`,
};

export const ADVANTAGES = {
  title: '方案优势',
  details: [
    {
      title: '更强大的内容理解能力，实现精准推荐',
      content:
        '基于多模态内容理解，精确识别商品元素，实现万物检索。更能精准提炼内容主旨，真实还原用户表达意图\n\n做到“想用户所想”、“推用户想看”，持续为用户种草，提高购买转化率',
      iconUrl: `${path}/3d-icon1.webp`,
      mobileIconUrl: `${path}/3d-icon1.webp`,
    },
    {
      title: '更精准的智能AI，实现在线讲解、试穿试戴',
      content:
        '行业领先的AI算法，识别人脸、脖颈、手部等多个部位关键点，结合美颜特效，精准还原美妆效果，还原线下试穿试戴体验\n\n通过AI智能助手，一键制作商品讲解视频，降低投入成本，提升产出效率',
      iconUrl: `${path}/3d-icon2.webp`,
      mobileIconUrl: `${path}/3d-icon2.webp`,
    },
    {
      title: '真正实现“不断播”，打造在线品牌发布会',
      content:
        '直播零门槛，一键就开播。虚拟主播不喊累，24小时随时在线\n\n端云结合，实现大空间、超高炫酷虚拟场景，实现品牌在线发布与宣传',
      iconUrl: `${path}/3d-icon3.webp`,
      mobileIconUrl: `${path}/3d-icon3.webp`,
    },
  ],
};

export const BRAND = {
  title: '客户案例',
  items: ['快手'],
};

export const USECASE = {
  title: '使用场景',
  items: [
    {
      title: '“7x24”不断档直播',
      subTitle:
        '虚拟主播实时在线，满足用户不同时间段消费需求\nAI智能问答，精准答疑，让用户随心选购',
      picUrl: `${path}/usecase1.webp`,
    },
    {
      title: '短视频商品种草',
      subTitle:
        '完美理解用户消费画像，为用户持续种草\n识别视频商品，实现“一键推荐”',
      picUrl: `${path}/usecase2.webp`,
    },
    {
      title: 'AI试穿试戴',
      subTitle:
        '提供包括在线试妆、在线试衣、在线试配饰等多商品试用能力行业领先的AI算法，试穿试戴效果更真实、更自然、更服贴',
      picUrl: `${path}/usecase3.webp`,
    },
  ],

  picUrl: `${path}/peitu.webp`,
};

export const NAV = ['方案架构', '方案优势', '使用场景'];
